import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';

import { Box } from '@mui/system';

import StyledTextField from '../../../../styled/TextField';

import VirtualTable from '../../../../partials/VirtualTable';

const columns = [
    { id: 'segment', title: 'Seg', numeric: true, style: { minWidth: '55px' } },
    { id: 'position', title: 'Pos', numeric: true, style: { minWidth: '55px' } },
    { id: 'art_number', title: 'ArtNr', numeric: false,
        style: { overflow: 'hidden', whiteSpace: 'nowrap', textOverflow: 'ellipsis', minWidth: '160px' } },
    { id: 'description', title: 'Descriptions', numeric: false,
        style: { overflow: 'hidden', whiteSpace: 'nowrap', textOverflow: 'ellipsis', minWidth: '320px' } },
    { id: 'barcode', title: 'EAN', numeric: true, style: { minWidth: '128px' } },
    { id: 'quantity', title: 'Quantity', numeric: true, style: { minWidth: '96px' } },
];

function Report({elements})
{
    const { t } = useTranslation();

    const [search, setSearch] = useState('');
    const [filteredElements, setFilteredElements] = useState(null);

    const filter = (event) => {
        const keyword = event.target.value;
        setSearch(keyword);
  
        if (keyword !== '') {
            const filtered = elements.filter((element) => {
                const data = element.art_number + ' ' + element.description + ' ' + element.description2 + ' ' + element.barcode;
                return data.toLowerCase().includes(keyword.toLowerCase());
            });
            setFilteredElements(filtered);
        } else {
            setFilteredElements(null);
        }
    };

    return (
        <>
            <StyledTextField
                fullWidth
                size="small"
                variant="outlined"
                label={t('Search')}
                value={search}
                onChange={filter}
            />
            <Box sx={{ paddingTop: 2, height: 'calc(100% - 40px)' }}>
                <VirtualTable
                    rows={filteredElements || elements}
                    columns={columns}
                    rowHeight={50}
                />
            </Box>
        </>
    );
}

export default Report;